<template>
  <v-container>
    <v-text-field
      label="Наименование технологии"
      v-model="name"
      @input="$v.name.$touch()"
      @blur="$v.name.$touch()"
      :error-messages="nameErrors"
    />

    <v-select
      label="Область примененения"
      v-model="application"
      :items="dict100"
      multiple
      chips
      item-value="code"
      item-text="value"
      @input="$v.application.$touch()"
      @blur="$v.application.$touch()"
      :error-messages="applicationErrors"
    />

    <v-textarea
      label="Источник информации о ИТЗ"
      v-model="infoSource"
      rows="1"
      auto-grow
    />

    <attached-files
      label="Загружаемые данные"
      fieldName="infoSourceFiles"
      :cardId="id"
      :uNumber="uNumber"
    />

    <v-textarea
      label="Краткое описание функционала"
      v-model="description"
      rows="1"
      auto-grow
    />

    <v-select
      label="Характер технологии (преимущественный)"
      v-model="technologyCharacter"
      :items="technologyCharacters"
      item-value="code"
      item-text="value"
    />
    <v-select
      label="Уровни и условия оказания медицинской помощи"
      v-model="levels"
      :items="dict26"
      multiple
      chips
      item-value="code"
      item-text="value"
    />

    <v-select
      label="Уровень технологической зрелости"
      v-model="maturityLevel"
      :items="maturityLevels"
      item-value="code"
      item-text="value"
    />

    <v-select
      label="Основной профиль (соц/мед)"
      v-model="profiles"
      :items="dict4"
      multiple
      chips
      item-value="code"
      item-text="value"
    />

    <v-select
      label="Дисциплинарная направленность"
      v-model="subjectOrientations"
      :items="dict28"
      multiple
      chips
      item-value="code"
      item-text="value"
    />

    <v-textarea
      v-if="moreThanMaturityLevel"
      label="Наличие пилотных проектов"
      v-model="pilotProject"
      rows="1"
      auto-grow
      hint="Укажите где и какие, отличается от опыта практического применения проектным (разовым) характером"
    />

    <attached-files
      v-if="moreThanMaturityLevel"
      label="Загружаемые данные"
      fieldName="pilotProjectFiles"
      :cardId="id"
      :uNumber="uNumber"
    />

    <v-select
      label="Целевые аудитории"
      v-model="targetAudiences"
      :items="dict25"
      multiple
      chips
      item-value="code"
      item-text="value"
    />

    <v-textarea
      label="Опыт практического применения"
      v-model="applicationExperience"
      rows="1"
      auto-grow
      hint="указать где, когда, под чьим руководством, наличие отзыва и/или заключения врача"
    />
  </v-container>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import { GETTERS, MUTATIONS } from "@/store";
import AttachedFiles from "@/components/AttachedFiles";
import { required } from "vuelidate/lib/validators";

export default {
  name: "ExpressCard",
  components: { AttachedFiles },
  props: {
    id: { type: Number, required: true },
    fullscreen: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  validations: {
    application: { required },
    name: { required },
  },

  data: () => ({
    year: [2010, 2011, 2012, 2013, 2014, 2015, 2016, 2017, 2018, 2019, 2020],
    maturityLevels: [
      { code: "1", value: "Идея (TRL 1-3)" },
      { code: "2", value: "Технология (TRL 4-5)" },
      { code: "3", value: "Модель/Прототип (TRL 6-7)" },
      { code: "4", value: "Продукт (TRL 8-9)" },
    ],
    technologyCharacters: [
      { code: "1", value: "информационная (программная)" },
      { code: "2", value: "программно-аппаратная" },
      { code: "3", value: "инструментальная (аппаратная)" },
      { code: "4", value: "организационно-методическая" },
    ],
  }),
  computed: {
    ...mapGetters({
      card: GETTERS.CARD_DATA,
      dict4: GETTERS.DICTIONARY_4,
      dict25: GETTERS.DICTIONARY_25,
      dict26: GETTERS.DICTIONARY_26,
      dict28: GETTERS.DICTIONARY_28,
      dict100: GETTERS.DICTIONARY_100,
      getDictionaryItem: GETTERS.DICTIONARY_ITEM,
    }),

    application: {
      get() {
        return this.card.application;
      },
      set(value) {
        this.modify({ application: value });
      },
    },

    applicationErrors() {
      const errors = [];
      if (!this.$v.application.required) {
        errors.push("заполните обязательное поле!");
      }
      return errors;
    },

    // name, infoSource, description, maturityLevel, profiles, pilotProject, targetAudiences, levels, applicationExperience
    // infoSourceFiles
    uNumber() {
      return this.card.uNumber;
    },
    name: {
      get() {
        return this.card.name;
      },
      set(value) {
        this.modify({ name: value });
      },
    },
    nameErrors() {
      const errors = [];
      if (!this.$v.name.required) {
        errors.push("заполните обязательное поле!");
      }
      return errors;
    },

    infoSource: {
      get() {
        return this.card.infoSource;
      },
      set(value) {
        this.modify({ infoSource: value });
      },
    },
    infoSourceFiles: {
      get() {
        return this.card.infoSourceFiles;
      },
      set(value) {
        this.modify({ infoSourceFiles: value });
      },
    },
    description: {
      get() {
        return this.card.description;
      },
      set(value) {
        this.modify({ description: value });
      },
    },
    technologyCharacter: {
      get() {
        return this.card.technologyCharacter;
      },
      set(value) {
        this.modify({ technologyCharacter: value });
      },
    },
    maturityLevel: {
      get() {
        return this.card.maturityLevel;
      },
      set(value) {
        this.modify({ maturityLevel: value });
      },
    },
    profiles: {
      get() {
        return this.card.profiles;
      },
      set(value) {
        this.modify({ profiles: value });
      },
    },
    subjectOrientations: {
      get() {
        return this.card.subjectOrientations;
      },
      set(value) {
        this.modify({ subjectOrientations: value });
      },
    },
    pilotProject: {
      get() {
        return this.card.pilotProject;
      },
      set(value) {
        this.modify({ pilotProject: value });
      },
    },
    pilotProjectFiles: {
      get() {
        return this.card.pilotProjectFiles;
      },
      set(value) {
        this.modify({ pilotProjectFiles: value });
      },
    },
    targetAudiences: {
      get() {
        return this.card.targetAudiences;
      },
      set(value) {
        this.modify({ targetAudiences: value });
      },
    },
    levels: {
      get() {
        return this.card.levels;
      },
      set(value) {
        this.modify({ levels: value });
      },
    },
    applicationExperience: {
      get() {
        return this.card.applicationExperience;
      },
      set(value) {
        this.modify({ applicationExperience: value });
      },
    },
    moreThanMaturityLevel() {
      const code = this.maturityLevel;
      if (code === "3" || code === "4") {
        return true;
      }
      return false;
    },
    invalid() {
      return this.$v.$invalid;
    },
  },
  methods: {
    ...mapMutations({
      modify: MUTATIONS.MODIFY_CARD_DATA,
    }),
    formatTree(idx, code) {
      const item = this.getDictionaryItem(idx, code);
      return item ? `${item.code} ${item.value}` : "";
    },
  },
  watch: {
    invalid(value) {
      this.$emit("change-invalid", value);
    },
  },
};
</script>
